import {createContext} from "react";

export const SortContext = createContext({
    asc: true,
    desc: false,
    sortBy: 'name',
    setAsc: () => {},
    setDesc: () => {},
    setSortBy: () => {}
});